var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M7 2.865c1.351 0 2.568.385 3.649 1.155A6.605 6.605 0 0113 7a6.605 6.605 0 01-2.351 2.98c-1.081.77-2.298 1.155-3.649 1.155S4.432 10.75 3.351 9.98A6.605 6.605 0 011 7a6.605 6.605 0 012.351-2.98C4.432 3.25 5.649 2.865 7 2.865zm0 .77c-.946 0-1.743.324-2.392.973-.649.649-.973 1.446-.973 2.392s.324 1.743.973 2.392c.649.649 1.446.973 2.392.973s1.743-.324 2.392-.973c.649-.649.973-1.446.973-2.392s-.324-1.743-.973-2.392C8.743 3.959 7.946 3.635 7 3.635zM7 5.5c.432 0 .791.142 1.074.426.284.283.426.642.426 1.074 0 .432-.142.791-.426 1.074-.283.284-.642.426-1.074.426-.432 0-.791-.142-1.074-.426C5.642 7.791 5.5 7.432 5.5 7c0-.432.142-.791.426-1.074C6.209 5.642 6.568 5.5 7 5.5z"
  })));
}
export default SvgPublic;